class TcConfigMessage extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    const section = this.closest('.shopify-section, dialog, product-card');
    this.field = this.querySelector('textarea');
    this.applyState(this.dataset.messageEnabled === 'true');
    section?.addEventListener('variant:update', (event) => {
      const productId = event.detail?.data?.productId;
      if (productId && String(productId) !== this.dataset.productId) return;
      const updated = event.detail?.data?.html?.querySelector(`tc-config-message[data-product-id="${this.dataset.productId}"]`);
      if (updated) this.applyState(updated.dataset.messageEnabled === 'true');
    }, { signal });
    section?.addEventListener('variant:selected', () => {
      this.changing = true;
    }, { signal });
    this.field?.addEventListener('input', () => this.field.setCustomValidity(''), { signal });
    this.field?.addEventListener('focus', () => this.updatePlaceholder(), { signal });
    window.addEventListener('focus', () => this.updatePlaceholder(), { signal });
    section?.addEventListener('submit', (event) => {
      if (event.target !== this.field?.form) return;
      if (this.changing) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      if (!this.hidden && !this.field.value.trim()) {
        this.field.setCustomValidity(this.dataset.requiredMessage);
        event.preventDefault();
        event.stopImmediatePropagation();
        this.field.reportValidity();
      }
    }, { signal, capture: true });
  }
  disconnectedCallback() {
    this.controller?.abort();
  }
  applyState(enabled) {
    this.changing = false;
    this.hidden = !enabled;
    this.dataset.messageEnabled = String(enabled);
    if (!this.field) return;
    this.updatePlaceholder();
    this.field.disabled = !enabled;
    this.field.required = enabled;
    this.field.setCustomValidity('');
    if (!enabled) this.field.value = '';
  }
  updatePlaceholder() {
    const template = this.field?.dataset.placeholderTemplate;
    if (!template) return;
    const date = new Intl.DateTimeFormat('ro-RO', {
      timeZone: 'Europe/Bucharest', day: '2-digit', month: '2-digit', year: 'numeric'
    }).format(new Date());
    this.field.placeholder = template.replace('__TC_CURRENT_DATE__', date);
  }
}
if (!customElements.get('tc-config-message')) {
  customElements.define('tc-config-message', TcConfigMessage);
}
